import { render, staticRenderFns } from "./ConfigMenuList.vue?vue&type=template&id=6275e2df"
import script from "./ConfigMenuList.vue?vue&type=script&lang=js"
export * from "./ConfigMenuList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports